import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000';

const DEPORTE_CONFIG = {
  futbol: { icono: '⚽', label: 'Fútbol',  color: '#16A34A', desc: 'la plataforma de fútbol amateur de Chile' },
  padel:  { icono: '🎾', label: 'Pádel',   color: '#1A6BFF', desc: 'la plataforma de pádel amateur de Chile' },
  tenis:  { icono: '🎾', label: 'Tenis',   color: '#7C3AED', desc: 'la plataforma de tenis amateur de Chile' },
};

function formatFecha(fechaStr) {
  if (!fechaStr) return '';
  try {
    const [y, m, d] = String(fechaStr).slice(0, 10).split('-').map(Number);
    return new Date(y, m - 1, d).toLocaleDateString('es-CL', { day: 'numeric', month: 'short', year: 'numeric' });
  } catch { return fechaStr; }
}

function labelModalidad(modalidad) {
  const labels = { pierde_paga: '🏆 Pierde Paga', pago_medias: '🤝 Pago a Medias', invitacion: '🎁 Invitación' };
  return labels[modalidad] || '🤝 Pago a Medias';
}

function labelFormato(formatoSets) {
  const labels = {
    '2sets_supertb':        '2 Sets + Súper TB',
    '2sets_puntoro':        '2 Sets + Punto de Oro',
    '2sets_puntoro_supertb':'2 Sets + Punto de Oro + Súper TB',
  };
  return labels[formatoSets] || '';
}

export default function PaginaUnete() {
  const { deporte, token } = useParams();
  const navigate           = useNavigate();
  const [inv,      setInv]      = useState(null);
  const [error,    setError]    = useState('');
  const [cargando, setCargando] = useState(true);

  const cfg = DEPORTE_CONFIG[deporte] || DEPORTE_CONFIG.futbol;

  useEffect(() => {
    fetch(`${API}/api/invitaciones/externa/${token}`)
      .then(r => r.json())
      .then(data => {
        if (data.error) setError(data.error);
        else setInv(data);
      })
      .catch(() => setError('No se pudo cargar la invitación'))
      .finally(() => setCargando(false));
  }, [token]);

  const handleUnirse = () => {
    localStorage.setItem('turival_invitacion_externa_token', token);
    localStorage.setItem('turival_deporte_login', deporte);
    navigate('/login');
  };

  if (cargando) {
    return (
      <div style={styles.pagina}>
        <div style={styles.card}>
          <div style={styles.logo}>Tu<span style={styles.naranja}>Rival</span></div>
          <div style={styles.cargando}>Cargando invitación...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.pagina}>
        <div style={styles.card}>
          <div style={styles.logo}>Tu<span style={styles.naranja}>Rival</span></div>
          <div style={styles.errorIcono}>⚠️</div>
          <div style={styles.errorTitulo}>
            {error === 'Esta invitación ya fue usada' ? 'Invitación ya utilizada'
              : error === 'Esta invitación ha expirado' ? 'Invitación expirada'
              : 'Invitación no válida'}
          </div>
          <div style={styles.errorSub}>
            {error === 'Esta invitación ya fue usada'
              ? 'Ya te registraste. Entra directo a TuRival.'
              : 'Esta invitación ya no está disponible. Pide una nueva a tu rival.'}
          </div>
          <button style={styles.btnPrincipal} onClick={() => navigate('/login')}>
            Ir a TuRival
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.pagina}>
      <div style={styles.card}>
        <div style={styles.logo}>Tu<span style={styles.naranja}>Rival</span></div>

        <div style={styles.deporteIcono}>{cfg.icono}</div>

        {inv?.tipo === 'desafio' ? (
          <>
            <div style={styles.titulo}>¡Te están desafiando!</div>
            <div style={styles.sub}>
              <strong>{inv.invitador_nombre}</strong> te lanzó un desafío de {cfg.label} en TuRival.
            </div>

            {/* Info del desafío */}
            <div style={styles.desafioCard}>
              <div style={styles.desafioVs}>
                <div style={styles.desafioEquipo}>{inv.local_nombre || inv.invitador_nombre}</div>
                <div style={styles.desafioVsLabel}>VS</div>
                <div style={styles.desafioEquipo}>TÚ</div>
              </div>
              <div style={styles.desafioMeta}>
                {inv.fecha && <div style={styles.metaItem}>📅 {formatFecha(inv.fecha)} · {inv.hora}</div>}
                {inv.recinto_nombre && <div style={styles.metaItem}>🏟️ {inv.recinto_nombre}</div>}
                {inv.modalidad_pago && <div style={styles.metaItem}>💳 {labelModalidad(inv.modalidad_pago)}</div>}
                {inv.formato_sets && deporte !== 'futbol' && (
                  <div style={styles.metaItem}>
                    🎮 {inv.modalidad_juego === 'dobles' ? 'Dobles' : 'Individual'} · {labelFormato(inv.formato_sets)} · {inv.tipo_partido === 'amistoso' ? '🤝 Amistoso' : '🏅 Oficial'}
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          <>
            <div style={styles.titulo}>¡{inv?.invitador_nombre} te invita a jugar!</div>
            <div style={styles.sub}>
              Únete a TuRival, {cfg.desc}.
            </div>
          </>
        )}

        {/* Propuesta de valor */}
        <div style={styles.propuesta}>
          <div style={styles.propuestaTitulo}>¿Qué es TuRival?</div>
          <div style={styles.propuestaItems}>
            <div style={styles.propuestaItem}>🏆 Organiza partidos y registra resultados</div>
            <div style={styles.propuestaItem}>📊 ELO real · Ranking por zona</div>
            <div style={styles.propuestaItem}>📱 Todo desde el celular</div>
          </div>
          <div style={styles.slogan}>⚡ ¡Conectá · Desafiá · Jugá!</div>
          <div style={styles.propuestaFrase}>"El deporte amateur merece organización profesional"</div>
        </div>

        {/* Pasos */}
        <div style={styles.pasos}>
          <div style={styles.pasoItem}>
            <div style={styles.pasoNum}>1</div>
            <div style={styles.pasoTexto}>Regístrate gratis con Google en 2 minutos</div>
          </div>
          <div style={styles.pasoItem}>
            <div style={styles.pasoNum}>2</div>
            <div style={styles.pasoTexto}>
              {inv?.tipo === 'desafio'
                ? 'Acepta o rechaza el desafío'
                : 'Crea tu perfil y busca rivales'}
            </div>
          </div>
          <div style={styles.pasoItem}>
            <div style={styles.pasoNum}>3</div>
            <div style={styles.pasoTexto}>¡A jugar!</div>
          </div>
        </div>

        <button style={styles.btnPrincipal} onClick={handleUnirse}>
          ⚡ Registrarme y {inv?.tipo === 'desafio' ? 'ver el desafío' : 'unirme'}
        </button>

        <div style={styles.expira}>Esta invitación expira en 48 horas</div>
      </div>
    </div>
  );
}

const styles = {
  pagina: {
    minHeight: '100vh', background: '#0D1117',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
  },
  card: {
    background: '#161C26', border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 20, padding: 36, width: '100%', maxWidth: 420, textAlign: 'center',
  },
  logo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 32, fontWeight: 800, color: 'white', marginBottom: 16,
  },
  naranja: { color: '#FF6B1A' },
  deporteIcono: { fontSize: 48, marginBottom: 8 },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: 'white', marginBottom: 8,
  },
  sub: {
    fontSize: 13, color: 'rgba(255,255,255,0.5)',
    fontFamily: "'Barlow', sans-serif", marginBottom: 20, lineHeight: 1.6,
  },
  cargando: { color: 'rgba(255,255,255,0.4)', fontSize: 14, fontFamily: "'Barlow', sans-serif" },
  errorIcono: { fontSize: 48, marginBottom: 12 },
  errorTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 22, fontWeight: 800, color: 'white', marginBottom: 8,
  },
  errorSub: {
    fontSize: 13, color: 'rgba(255,255,255,0.4)',
    fontFamily: "'Barlow', sans-serif", marginBottom: 24, lineHeight: 1.6,
  },
  desafioCard: {
    background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 14, padding: '16px 20px', marginBottom: 20, textAlign: 'left',
  },
  desafioVs: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    gap: 12, marginBottom: 12,
  },
  desafioEquipo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 800, color: 'white', flex: 1, textAlign: 'center',
  },
  desafioVsLabel: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 13, fontWeight: 700, color: '#FF6B1A',
  },
  desafioMeta: {
    borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 10,
    display: 'flex', flexDirection: 'column', gap: 4,
  },
  metaItem: { fontSize: 12, color: 'rgba(255,255,255,0.5)', fontFamily: "'Barlow', sans-serif" },
  propuesta: {
    background: 'rgba(255,107,26,0.08)', border: '1px solid rgba(255,107,26,0.2)',
    borderRadius: 14, padding: '16px', marginBottom: 20, textAlign: 'left',
  },
  propuestaTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 14, fontWeight: 800, color: '#FF6B1A', marginBottom: 10,
  },
  propuestaItems: { display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 },
  propuestaItem: { fontSize: 12, color: 'rgba(255,255,255,0.6)', fontFamily: "'Barlow', sans-serif" },
  slogan: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 800, color: '#FF6B1A', marginBottom: 6,
  },
  propuestaFrase: {
    fontSize: 11, color: 'rgba(255,255,255,0.3)',
    fontFamily: "'Barlow', sans-serif", fontStyle: 'italic',
  },
  pasos: { display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 24, textAlign: 'left' },
  pasoItem: { display: 'flex', alignItems: 'center', gap: 12 },
  pasoNum: {
    width: 24, height: 24, borderRadius: '50%', background: '#FF6B1A',
    color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 12, fontWeight: 800, flexShrink: 0,
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  pasoTexto: { fontSize: 13, color: 'rgba(255,255,255,0.6)', fontFamily: "'Barlow', sans-serif", lineHeight: 1.4 },
  btnPrincipal: {
    width: '100%', padding: '14px', background: '#FF6B1A', border: 'none',
    borderRadius: 12, cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 800, color: 'white', marginBottom: 12,
  },
  expira: {
    fontSize: 11, color: 'rgba(255,255,255,0.25)',
    fontFamily: "'Barlow', sans-serif", fontStyle: 'italic',
  },
};
